<template>
    <div id="parent">
    </div>
</template>

<script>
import SignaturePad from "signature_pad";

export default {
    props: {
        title: String,
        type: String,
        initialPoints: Array
    },

    data: function () {
        return {
            canvas: null,
            buttonHeight: null,
            signaturePad: null,
        };
    },

    methods: {
        clearCanvas: function () {
            this.signaturePad.clear();
        },
        paintSignature() {
            if (!this.signaturePad) {
                try {
                    this.signaturePad = new SignaturePad(this.canvas);
                } catch (err) {
                    console.error("err:  ", err);
                }
            }
        },

        resizeCanvas() {
            let ratio = Math.max(window.devicePixelRatio || 1, 1);
            this.canvas.width = this.canvas.offsetWidth * ratio;
            this.canvas.height = this.canvas.offsetHeight * ratio;
            this.canvas.getContext("2d").scale(ratio, ratio);
            this.signaturePad.clear();
        },

        getNewHeightWidthScreen(callResize = true, firstRender = false) {
            const pwaClient = window.matchMedia("(display-mode: standalone)").matches;
            const parentHeight = document.getElementById("parent").offsetHeight;
            if (firstRender) {
                const windowHeight =
                    parentHeight -
                    this.buttonHeight;
                const windowWidth = window.innerWidth;
                this.canvas.setAttribute("width", windowWidth);
                this.canvas.setAttribute("height", windowHeight);
            } else if (
                (window.matchMedia("(orientation: landscape)").matches && pwaClient) ||
                (window.matchMedia("(orientation: portrait)").matches && !pwaClient)
            ) {
                const windowHeight =
                    parentHeight -
                    this.buttonHeight;
                const windowWidth = window.innerWidth;
                this.canvas.setAttribute("width", windowWidth);
                this.canvas.setAttribute("height", windowHeight);
            } else {
                const windowHeight =
                    window.innerWidth -
                    this.buttonHeight;
                const windowWidth = parentHeight;
                this.canvas.setAttribute("width", windowWidth);
                this.canvas.setAttribute("height", windowHeight);
            }
            if (callResize) this.resizeCanvas();
        },

        captureSignature: function () {
            const signaturePoints = this.signaturePad.toData();
            const signatureURL = this.signaturePad.toDataURL();
            return { signaturePoints, signatureURL };
        },

        checkLandscape() {
            if (window.matchMedia("(orientation: landscape)").matches) {
                return "landscape";
            }
            return null;
        },
    },

    mounted: function () {
        this.buttonHeight =
            document.getElementsByClassName("container-buttons")[0].clientHeight;
        this.canvas = document.createElement("canvas");
        this.paintSignature();
        this.getNewHeightWidthScreen(false, true);
        this.canvas.setAttribute("id", "canvas");
        this.context = this.canvas.getContext("2d");

        // window.addEventListener('resize', this.resizeCanvas)
        window.addEventListener("orientationchange", this.getNewHeightWidthScreen);

        if(this.initialPoints != null){
            this.signaturePad.fromData(this.initialPoints);
        }

        const divParent = document.getElementById("parent");
        divParent.prepend(this.canvas);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.resizeCanvas);
        window.removeEventListener("orientationchange", this.getNewHeightWidthScreen);
    },
};
</script>

<style scoped>
#parent {
    height: 100%;
}

#canvas {
    touch-action: none;
}

.signature {
    margin: 10px 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

#canvas-container {
    width: 100%;
    height: 320px;
    position: relative;
    overflow: hidden;
}
</style>
